module.exports = __webpack_public_path__ + "img/xtb-dark.7f975f4f.png";